














































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyList, MyForm) {
  dispatchType = "finance/getReconciliactionDetail";

  @Prop() oldData!: any;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "头像",
      scopedSlots: { customRender: "avatar" }
    },
    {
      title: "用户名",
      dataIndex: "username"
    },
    {
      title: "手机号",
      dataIndex: "mobile"
    },
    {
      title: "金额",
      dataIndex: "fee",
      customRender(text: any, record: any, index: number) {
        return text / 100;
      }
    },
    {
      title: "下单时间",
      dataIndex: "created_time"
    },
    {
      title: "打球结束时间",
      dataIndex: "valid_time_end"
    },
    {
      title: "订单类型",
      dataIndex: "title"
    },
    {
      title: "交易单号",
      dataIndex: "trade_no"
    },
    {
      title: "支付方式",
      dataIndex: "channel_name"
    }
  ];

  async mounted() {
    // this.searchData.user_id = this.oldData.user_id
    this.loadData(
      {
        user_id: this.oldData.user_id
      },
      false
    );
    // const res = await this.$store.dispatch('finance/getReconciliactionDetail', {
    //   user_id: this.oldData.user_id
    // })
    // console.log(res)
    // if(res && res.Message && res.Data){
    //   this.Data =
    // }
  }
}
